import React from 'react';
import Layout from './tabs/Layout';
import Legal from './tabs/Legal';
import Master from './tabs/Master';
import PaymentOptions from './tabs/PaymentOptions';
import Websites from './tabs/Websites';
import CommunicationChannels from './tabs/CommunicationChannels';
export var Tab;
(function (Tab) {
    Tab["MASTER"] = "MASTER";
    Tab["LAYOUT"] = "LAYOUT";
    Tab["WEBSITES"] = "WEBSITES";
    Tab["LEGAL"] = "LEGAL";
    Tab["PAYMENT_OPTIONS"] = "PAYMENTOPTIONS";
    Tab["COMMUNICATION_CHANNELS"] = "COMMUNICATION_CHANNELS";
})(Tab || (Tab = {}));
const TabComponent = (props) => {
    switch (props.tab) {
        case Tab.MASTER:
            return React.createElement(Master, { collector: props.collector, lang: props.lang });
        case Tab.LAYOUT:
            return React.createElement(Layout, { collector: props.collector, lang: props.lang });
        case Tab.WEBSITES:
            return (React.createElement(Websites, { collector: props.collector, heading: props.lang.collectors.websites }));
        case Tab.LEGAL:
            return (React.createElement(Legal, { collector: props.collector, heading: props.lang.collectors.legal }));
        case Tab.PAYMENT_OPTIONS:
            return (React.createElement(PaymentOptions, { collectorId: props.collector.collectorId, heading: props.lang.collectors.paymentOptions, paymentOptions: props.collector.paymentOptions }));
        case Tab.COMMUNICATION_CHANNELS:
            return (React.createElement(CommunicationChannels, { collector: props.collector, heading: props.lang.collectors.communicationChannels, lang: props.lang }));
    }
};
export default TabComponent;
//# sourceMappingURL=TabComponent.js.map